import { Grid, Pagination } from '@/molecules';

import { usePagination } from '@/hooks';
import { toArray } from '@/utils';

import type { FunctionComponent } from 'react';
import type { TypeCardsPaginationProps } from './types';

export const CardsPagination: FunctionComponent<TypeCardsPaginationProps> = ({
  className = '',
  children,
}: TypeCardsPaginationProps) => {
  const { currentItems, currentPage, handlePageChange } = usePagination(
    toArray(children)
  );

  return (
    <div className={`flex flex-col gap-20 ${className}`}>
      <Grid xxs={1} sm={2} lg={3} className="gap-6">
        {currentItems.map((item, index) => (
          <Grid.Item key={index}>{item}</Grid.Item>
        ))}
      </Grid>

      <Pagination
        onPageChange={handlePageChange}
        pageCount={currentPage}
        className="mx-auto"
      />
    </div>
  );
};

CardsPagination.displayName = 'CardsPagination';
